export default {
  errorCode: 'ERROR CODE',
  generic: 'Something went wrong. Please try again later.',
  login: 'Sign-in failed. Please try again later.',
  loadProfile: 'Unable to load wallet account data.',
  sessionExpired: 'Your sign-in session has expired. Please sign in again.',
  loginState: 'Unable to read sign-in status. Please reopen the app.',
  signOut: 'Sign-out failed. Please try again later.',
  metaMaskBalance: 'Unable to load MetaMask balances.',
  metaMaskActivity: 'Unable to load transaction activity.',
  walletActivity: 'Unable to load Bubble Wallet activity.',
  metaMaskConnect: 'MetaMask connection failed.',
  metaMaskDisconnect: 'Unable to disconnect MetaMask.',
  priceQuery: 'Unable to load token prices.',
  bbgBalance: 'Unable to load BBG balance.',
  fcashBalance: 'Unable to load F-CASH balance.',
  flight404SessionExpired: 'Your sign-in has expired. Please sign in again.',
  claimStatus: 'Unable to read BBG claim status.',
  claimFailed: 'BBG claim failed.',
  sendFailed: 'Send failed. Please try again later.',
  swapFailed: 'Swap failed. Please try again later.',
  centralSsoNotConfigured: 'Central GGMOMOMO sign-in is not configured.',
  centralSsoIssuerMismatch: 'The central sign-in issuer does not match this wallet environment.',
  centralSsoStorageFailed: 'Unable to save central sign-in state. Please try again later.',
  centralSsoStateMismatch: 'Central sign-in verification state does not match. Please sign in again.',
  centralSsoMissingCallback: 'The central sign-in response is incomplete. Please sign in again.',
  centralSsoTokenExchangeFailed: 'Unable to complete central sign-in. Please sign in again.',
  centralSsoInvalidTokenResponse: 'The central sign-in response is incomplete. Please sign in again.',
  centralSsoSessionFailed: 'Unable to create a Bubble Wallet session. Please sign in again.',
  centralSsoPopupBlocked: 'Unable to open the central sign-in window. Allow pop-ups and try again.',
  centralSsoPopupFailed: 'The central sign-in window could not start. Please try again later.',
  centralSsoPopupClosed: 'The central sign-in window was closed. Please sign in again.',
  accessDenied: 'You cancelled GGMOMOMO sign-in.',
  invalidRequest: 'The central sign-in request is invalid. Please sign in again.',
  invalidClient: 'The central sign-in client is not registered correctly.',
  invalidRedirectUri: 'The Bubble Wallet callback is not registered with central sign-in.',
  invalidGrant: 'The central sign-in has expired. Please sign in again.',
  pkceVerificationFailed: 'Central sign-in security verification failed. Please sign in again.',
  walletAuthNotConfigured: 'Wallet Auth is not configured.',
  worldAppUnavailable: 'Open Bubble Wallet in World App.',
  worldAppNotConfigured: 'World App setup is incomplete.',
  worldAppTimeout: 'World Wallet verification timed out. Please try again.',
  worldAppNetworkFailed: 'Unable to connect to Wallet Auth. Please try again later.',
  worldAppNonceFailed: 'Unable to create Wallet Auth verification. Please try again later.',
  worldAppRejected: 'You cancelled World Wallet verification.',
  worldAppWalletMissing: 'World Wallet did not return usable wallet data.',
  worldAppVerificationFailed: 'World Wallet verification failed. Please try again later.',
  worldAppSessionFailed: 'Unable to create a Bubble Wallet session. Please sign in again.',
  worldAppSignInFailed: 'World Wallet sign-in failed. Please try again later.',
  invalidWalletAddress: 'Please enter a valid wallet address.',
  invalidRecipientAddress: 'Please enter a valid recipient wallet address.',
  sameSwapTokens: 'Input and output tokens must be different.',
  swapAmountPositive: 'Swap amount must be greater than 0.',
  swapAmountExceedsBalance: 'Swap amount cannot exceed the current on-chain balance.',
  swapAmountPermitLimit: 'Swap amount exceeds the Permit2 supported limit.',
  quoteUnavailable: 'A valid quote is not available right now. Please try again later.',
  minimumOutputInvalid: 'Minimum output is invalid. Reduce the swap amount and try again.',
  erc20ApprovalFailed: 'The ERC-20 approval transaction failed.',
  permit2ApprovalFailed: 'The Permit2 approval transaction failed.',
  metaMaskConnectorMissing: 'MetaMask connector not found. Use the connect button to open MetaMask.',
  metaMaskWrongChain: 'MetaMask is not connected to World Chain. The transaction was cancelled.',
  metaMaskWalletMissing: 'MetaMask did not return a valid wallet address.',
  metaMaskCancelDisconnect: 'You cancelled the MetaMask disconnect request.',
  metaMaskManualDisconnect: 'Unable to disconnect MetaMask. Remove the website connection in MetaMask manually.',
  onChainBalanceFailed: 'On-chain balance query failed.',
  transactionNotConfirmed: 'The on-chain transaction is not confirmed yet. Check its status later.',
  transactionHistoryNotConfigured: 'The on-chain transaction history service is not configured.',
  transactionHistoryOffline: 'The on-chain transaction history service is temporarily unavailable.',
  transactionHistoryInvalid: 'The on-chain transaction history service returned an invalid response.',
  sendAmountPositive: 'Send amount must be greater than 0.',
  sendAmountExceedsBalance: 'Send amount cannot exceed the current on-chain balance.',
  sendAmountRequired: 'Enter a send amount.',
  priceServiceOffline: 'The price service is temporarily unavailable.',
  supabaseNotConfigured: 'Supabase is not configured, so the BBG in-game balance cannot be loaded.',
  worldAppTransactionIncomplete: 'World App did not complete this transaction.',
  worldAppUnknownOperation: 'World App returned an unrecognised User Operation status.',
  worldAppNativeTransactionRequired: 'Open Bubble Wallet in World App to continue this transaction.',
  worldAppNativeTransactionFailed: 'World App did not complete the transaction through native MiniKit.',
  worldAppUserOperationMissing: 'World App did not return a User Operation ID.',
  worldIdNotConfigured: 'A valid BubbleClaim contract address is not configured.',
  worldIdWalletMissing: 'A valid World App wallet address is not available.',
  worldIdContextMismatch: 'The World ID RP context does not match the current configuration.',
  worldIdContextSignatureMissing: 'The World ID RP context has no valid signature.',
  worldIdContextInvalid: 'The World ID RP context format is invalid.',
  worldIdRpContextUnavailable: 'Unable to load the World ID RP context. Please try again later.',
  worldIdRpIdMissing: 'A valid World ID RP ID is not configured.',
  worldIdSessionInvalid: 'The World ID canonical session ID format is invalid.',
  worldAppIdMissing: 'A valid World App ID is not configured.',
  worldIdSessionIdInvalid: 'The World ID session ID format is invalid.',
  claimAuthorizationInvalid: 'The claim authorization digest does not match the signed authorization.',
  enrollmentNotVisible: 'Enrollment was confirmed, but the wallet is not shown as enrolled on-chain.',
  claimUnavailable: 'Daily BBG claims are not currently available.',
  claimAmountMissing: 'The BBG claim amount is not configured.',
  patternInvalid: 'The pattern ID format is invalid.',
  rawTimeout: '{{label}} timed out. Please try again later.',
  rawConnectionFailed: '{{label}} could not connect. Please try again later.',
  amountDecimals: 'This amount supports at most {{decimals}} decimal places.',
  priceServiceResponse: 'The price service returned an error ({{status}}).',
  worldAppTransactionFailed: 'World App transaction failed.',
  worldAppTransactionFailedWithoutDetail: 'World App transaction failed.',
  worldAppPending: 'World App transaction is still pending.',
  worldAppSubmittedFailed: 'World App transaction failed on-chain.',
  worldAppAuthorizationWalletMismatch: 'The authorization wallet does not match the current World App wallet.',
  ssoPopupResponseMissing: 'The sign-in response could not be returned to Bubble Wallet. Close this window and sign in again.',
  claimAuthorizationConflict: 'Authorization conflict: this verification authorization does not match the current request. Verify again.',
  claimAuthorizationExpired: 'Authorization expired. Complete World ID verification again.',
  claimWalletMismatch: 'The authorization wallet does not match the current World App wallet. The cached authorization was cleared.',
  claimBackendUnavailable: 'Unable to get claim authorization. Please try again later.',
  claimCooldown: 'Claim cooldown: you are still within the claim cooldown period. Please try again later.',
  claimCapExhausted: 'Cap exhausted: the BBG claim cap has been reached.',
  claimStatusUnavailable: 'Unable to read the on-chain claim status. Please try again later.',
  claimInventoryInsufficient: 'Inventory insufficient: BBG claim inventory is temporarily unavailable.',
  claimInvalidAuthorization: 'The claim authorization response is invalid. Complete World ID verification again.',
  claimPatternNotAllowed: 'This pattern is not currently allowed by the backend.',
  claimSessionConflict: 'Session continuity conflict: this wallet has another canonical World ID session. Sign in again and retry.',
  claimTransactionCancelled: 'Transaction cancelled: you cancelled the World App transaction. The authorization can still be retried before it expires.',
  claimTransactionFailed: 'Transaction failed: the World App transaction did not complete. The authorization can still be retried before it expires.',
  claimWorldVerificationFailed: 'World verification failed: the World ID proof did not pass official verification.',
  transactionCancelled: 'Transaction cancelled.',
  transactionFailed: 'Transaction failed.',
} as const;
